<script setup>
/* Knopf "Select" (Markier-Modus der Kaderliste). Keine Filterfunktion — er steht neben der Suche, nicht im
   Filter-Bereich (F2). Nur für Rollen mit Recht (useSelection.canSelect: admin, board, data, staff). */
import { useSelection } from '../composables/useSelection.js';

const { selecting, canSelect, enter, done } = useSelection();
</script>

<template>
  <div v-if="canSelect" class="select-group">
    <button
      type="button"
      class="btn ghost small"
      :class="{ active: selecting }"
      :aria-pressed="selecting"
      data-testid="select-toggle"
      @click="selecting ? done() : enter()"
    >
      {{ $t('selection.select') }}
    </button>
  </div>
</template>

<style scoped>
.select-group .btn {
  position: relative;
}
/* Tippfläche mindestens 40 px, ohne den Knopf optisch größer zu machen */
.select-group .btn::after {
  content: '';
  position: absolute;
  inset: -6px -4px;
}
</style>
